/* tslint:disable */
import {
  Institutions
} from '../index';

declare var Object: any;
export interface FundsBudgetedInterface {
  "amount"?: number;
  "institution_id": number;
  "financial_year": string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  institutions?: Institutions;
}

export class FundsBudgeted implements FundsBudgetedInterface {
  "amount": number;
  "institution_id": number;
  "financial_year": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  institutions: Institutions;
  constructor(data?: FundsBudgetedInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FundsBudgeted`.
   */
  public static getModelName() {
    return "FundsBudgeted";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FundsBudgeted for dynamic purposes.
  **/
  public static factory(data: FundsBudgetedInterface): FundsBudgeted{
    return new FundsBudgeted(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FundsBudgeted',
      plural: 'FundsBudgeteds',
      path: 'FundsBudgeteds',
      properties: {
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "institution_id": {
          name: 'institution_id',
          type: 'number'
        },
        "financial_year": {
          name: 'financial_year',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        institutions: {
          name: 'institutions',
          type: 'Institutions',
          model: 'Institutions'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/FundsBudgeted.ts